import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import {Observable, Subject} from 'rxjs';
import {
	BarcodeMappingGridWithGlobalCompanyPrefixModelResult,
	BarcodeMappingToMasterGridModel,
	InconsistentServiceAndProductMappingForProductBarcodeAssignmentModelResult, ProcessingStatusForBarcodeMappingResultResult,
	ProductBarcodeAssignmentGridModelResult,
	ProductBarcodeAssignmentToMasterGridResultModel,
	ProductBarcodeMasterGridModelResult,
	ProductMasterWithSizeListGridModelResult,
	ProductBarcodeMappingOption
} from '../shared/models/product-barcode.model';
import {HeaderFilterData} from '../shared/models/product.model';
import {LoadOptions} from '../shared/models/shared.model';

@Injectable({providedIn: 'root'})

export class ProductBarcodeService {
	private token = localStorage.getItem('token');
	private headers = new HttpHeaders({'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token});

	private url = Constants.devServerEndpoint + 'api/productbarcode';

	constructor(private httpClient: HttpClient) { }

	public getProductBarcodeAssignmentGrid(param: any): Observable<ProductBarcodeAssignmentGridModelResult[]> {
		return this.httpClient.post<ProductBarcodeAssignmentGridModelResult[]>
		(this.url + `/getProductBarcodeAssignmentGrid`, param, { headers: this.headers });
	}

	public getProductBarcodeAssignmentGridHeaderFilters(param: any): Observable<HeaderFilterData[]> {
		return this.httpClient.post<HeaderFilterData[]>(this.url + `/getProductBarcodeAssignmentGridHeaderFilters`, param, { headers: this.headers });
	}

	public getProductBarcodeMasterGrid(param: any): Observable<ProductBarcodeMasterGridModelResult[]> {
		return this.httpClient.post<ProductBarcodeMasterGridModelResult[]>
		(this.url + `/getProductBarcodeMasterGrid`, param, { headers: this.headers });
	}

	public getProductBarcodeMasterGridHeaderFilters(param: any): Observable<HeaderFilterData[]> {
		return this.httpClient.post<HeaderFilterData[]>(this.url + `/getProductBarcodeMasterGridHeaderFilters`, param, { headers: this.headers });
	}

	public getGetProductBarcodeAssignmentToMasterGridResult(ProductBarcodeId: number):
		Observable<ProductBarcodeAssignmentToMasterGridResultModel[]> {
		return this.httpClient.get<ProductBarcodeAssignmentToMasterGridResultModel[]>
		(this.url + `/getGetProductBarcodeAssignmentToMasterGridResult/${ProductBarcodeId}`, { headers: this.headers });
	}

	public getProductMasterWithSizeListGrid(param: any): Observable<ProductMasterWithSizeListGridModelResult[]> {
		return this.httpClient.post<ProductMasterWithSizeListGridModelResult[]>
		(this.url + `/getProductMasterWithSizeListGrid`, param, { headers: this.headers });
	}

	public getProductMasterWithSizeListGridHeaderFilters(param: any): Observable<HeaderFilterData[]> {
		return this.httpClient.post<HeaderFilterData[]>
		(this.url + `/getProductMasterWithSizeListGridHeaderFilters`, param, { headers: this.headers });
	}

	public getBarcodeMappingGridWithGlobalCompanyPrefixResult(param: any): Observable<BarcodeMappingGridWithGlobalCompanyPrefixModelResult[]> {
		return this.httpClient.post<BarcodeMappingGridWithGlobalCompanyPrefixModelResult[]>
		(this.url + `/getBarcodeMappingGridWithGlobalCompanyPrefixResult`, param, { headers: this.headers });
	}

	public getBarcodeMappingGridWithGlobalCompanyPrefixHeaderFilters(param: any): Observable<HeaderFilterData[]> {
		return this.httpClient.post<HeaderFilterData[]>
		(this.url + `/getBarcodeMappingGridWithGlobalCompanyPrefixHeaderFilters`, param, { headers: this.headers });
	}

	public getBarcodeMappingToMasterGridResult(BarcodeMappingId: number): Observable<BarcodeMappingToMasterGridModel[]> {
		return this.httpClient.get<BarcodeMappingToMasterGridModel[]>
		(this.url + `/getBarcodeMappingToMasterGrid/${BarcodeMappingId}`, { headers: this.headers });
	}

	public getInconsistentServiceAndProductMappingForProductBarcodeAssignment(param: LoadOptions, ProductBarcodeId: number):
		Observable<InconsistentServiceAndProductMappingForProductBarcodeAssignmentModelResult[]> {
		return this.httpClient.post<InconsistentServiceAndProductMappingForProductBarcodeAssignmentModelResult[]>
		(this.url + `/getInconsistentServiceAndProductMappingForProductBarcodeAssignment`, {param, ProductBarcodeId}, { headers: this.headers });
	}

	public getProcessingStatusForBarcodeMappingResult(param: LoadOptions, BarcodeMappingId: number):
		Observable<ProcessingStatusForBarcodeMappingResultResult[]> {
		return this.httpClient.post<ProcessingStatusForBarcodeMappingResultResult[]>
		(this.url + `/getProcessingStatusForBarcodeMappingResult`, {param, BarcodeMappingId}, { headers: this.headers });
	}

	public productBarcodeMappingAction(params: ProductBarcodeMappingOption): Observable<any> {
		return this.httpClient.post<any>
		(this.url + `/productBarcodeMappingAction`, params, { headers: this.headers });
	}

	public barcodeMappingAction(params: ProductBarcodeMappingOption): Observable<any> {
		return this.httpClient.post<any>
		(this.url + `/barcodeMappingAction`, params, { headers: this.headers });
	}

	public lookupBarcode(barcode) {
		const url = `https://www.google.com/search?q=${encodeURIComponent(barcode)}`;
		window.open(url, '_blank');
	}
}
